module.exports = __webpack_public_path__ + "static/jeff-de236ddb90b5c4df44030fb746c683c5.jpg";